'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'boombox';
var width = 640;
var height = 512;
var aliases = [128254];
var unicode = 'f8a5';
var svgPathData = 'M64 0L80 0 560 0l16 0 0 16 0 144 32 0 32 0 0 32 0 288 0 32-32 0L32 512 0 512l0-32L0 192l0-32 32 0 32 0L64 16 64 0zM96 32l0 128 448 0 0-128L96 32zM32 192l0 288 576 0 0-288-48 0L80 192l-48 0zM256 336A80 80 0 1 0 96 336a80 80 0 1 0 160 0zM64 336a112 112 0 1 1 224 0A112 112 0 1 1 64 336zm400 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-192a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM208 96l32 0 16 0 0 32-16 0-32 0-16 0 0-32 16 0zm96 0l32 0 16 0 0 32-16 0-32 0-16 0 0-32 16 0zm96 0l32 0 16 0 0 32-16 0-32 0-16 0 0-32 16 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBoombox = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;